import { h } from 'vue';
import { RouterLink } from 'vue-router';
import _get from 'lodash/get';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';
import TimeFormat from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/TimeFormat.vue';
import UsedBy from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/UsedBy.vue';

const playersColumns: BuiTblColumn[] = [
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          { to: `/players/edit/${item.id}`, class: 'title-link', 'data-testid': 'list-row-title', onClick: (e: MouseEvent) => e.stopPropagation() },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.assetType ? `${item.assetType[0].toUpperCase()}${item.assetType.substring(1)}` : ''),
      ]),
  },
  {
    key: 'location',
    kind: 'text',
    label: 'Location',
    grow: true,
    minWidth: 110,
    render: ({ item }) => _get(item, 'location.groupName', 'None'),
  },
  {
    key: 'regCode',
    kind: 'text',
    label: 'Reg. Code',
    width: 120,
    render: ({ item }) => item.regCode || '',
  },
  {
    key: 'lastConnect',
    kind: 'text',
    label: 'Last Connected',
    grow: true,
    minWidth: 170,
    sortable: true,
    sortKey: 'lastConnectTime',
    render: ({ item }) => h(TimeFormat, { epochTime: item.lastConnectTime }),
  },
  {
    key: 'city',
    kind: 'text',
    label: 'City',
    grow: true,
    minWidth: 100,
    render: ({ item }) => _get(item, 'location.city', 'None'),
  },
  {
    key: 'state',
    kind: 'text',
    label: 'State',
    width: 90,
    render: ({ item }) => _get(item, 'location.state', 'None'),
  },
  {
    key: 'tags',
    kind: 'text',
    label: 'Tags',
    grow: true,
    minWidth: 130,
    render: ({ item }) => {
      const md = (item.metaDatas || []).filter((m: any) => !m.isDeleted);
      return h(
        'div',
        { class: 'bui-meta-list' },
        md.map((m: any) => h('div', { key: m.name }, `${m.name}: ${m.value}`)),
      );
    },
  },
  {
    key: 'usedBy',
    kind: 'usedBy',
    label: 'Used by',
    width: 80,
    render: ({ item }) =>
      h(UsedBy, { items: item.campaigns, label: 'Campaigns', count: item.campaignCount }),
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default playersColumns;
